import API_V2_URL from '@/constants/API_V2_URL';
import axios from 'axios';

const documentsService = {
  download(documentId) {
    return axios.get(`${API_V2_URL()}/folders/documents/${documentId}/download`);
  },
  getDocuments() {
    // return axios.get('folders/folders/received`);
  },
  getDocument(id) {
    return axios.get(`folders/documents/${id}`);
  },
  getDispatches() {
    return axios.get('documents/dispatches');
  },
  getDocumentTypes(query) {
    return axios.get(`${API_V2_URL()}/system/document_types/search?q=${query}`);
  },
  getDocumentType(id) {
    return axios.get(`folders/document_types/${id}`);
  },
  createNewDocument(folderId, documentTypeId, documentState) {
    return axios.post(
      `${API_V2_URL()}/folders/${folderId}/documents/create_document`,
      { document: { document_type_id: documentTypeId, document_state: documentState } });
  },
  updateDocument({ id, raw, filledFields, documentState, geolocation }) {
    return axios.put(
      `${API_V2_URL()}/folders/documents/${id}/update_document`,
      {
        document:
        {
          document_state: documentState,
          document_version: {
            document_raw: raw,
            filled_fields: filledFields,
          },
        },
        geolocation,
      });
  },
  async createNewPDFDocument(folderId, body, onUploadProgress) {
    return await axios.post(
      `${API_V2_URL()}/folders/${folderId}/documents/create_file`,
      body,
      { onUploadProgress },
    );
  },
  // createNewPDFDocument(folderId, body, onUploadProgress, transformRequest) {
  //   return axios.post(
  //     `${API_V2_URL()}/folders/${folderId}/documents/create_file`,
  //     { document: body, folder_id: folderId },
  //     { onUploadProgress, transformRequest: [transformRequest] },
  //   );
  // },
  async updatePDFDocument(documentId, body, geolocation) {
    return await(axios.put(
      `${API_V2_URL()}/folders/documents/${documentId}/update_file`,
      {
        document: { 0: body },
        geolocation,
      }));
  },
  destroyPDFDocument(documentId) {
    return axios.delete(`${API_V2_URL()}/folders/documents/${documentId}/destroy_file`);
  },
  removeDocument(id) {
    return axios.delete(`${API_V2_URL()}/folders/documents/${id}/destroy_document`);
  },
  signDocument(documentId, password, geolocation) {
    return axios.post(`${API_V2_URL()}/folders/documents/sign_document`, {
      document_id: documentId,
      geolocation,
      password,
    });
  },
};

export default documentsService;



// WEBPACK FOOTER //
// ./src/services/DocumentsService.js